import {
  Card,
  Divider,
  GKButton,
  GKTextField,
  Grid2,
  NoData,
  PlusIcon,
  SearchIcon,
  Show,
  TagBorderIcon,
  Typography,
} from "components";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetBasketsQuery,
  useGetOrderSimulationTemplatesQuery,
} from "store/features/EquityBasketAPI";
import { useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";
import useDocumentTitle from "utils/useDocumentTitle";
import CreateBasketModal from "./CreateBasketModal";
import EquityBasketCard from "./EquityBasketCard";

const EquityBasket = () => {
  const navigate = useNavigate();

  useDocumentTitle("Basket");

  const userData = useAppSelector((state) => state?.user?.userData);

  const [showCreateBasket, setShowCreateBasket] = useState(false);

  const [searchText, setSearchText] = useState("");

  const { data: orderSimulationTemplate } =
    useGetOrderSimulationTemplatesQuery();

  const { data, isFetching } = useGetBasketsQuery();

  return (
    <>
      <DashboardLayout title="Basket" loading={isFetching} disablePadding>
        <Grid2 container>
          <Grid2 size={12}>
            <Grid2 container spacing={1} px={3} py={1}>
              <Grid2 size={3} alignItems={"center"} display={"flex"}>
                <GKTextField
                  placeholder="Search..."
                  size="small"
                  type="search"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <SearchIcon
                          width={20}
                          height={20}
                          color={"var(--neutral-500)"}
                        />
                      ),
                    },
                  }}
                  sx={{
                    bgcolor: "#F8F8F8",
                  }}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
              </Grid2>
              <Grid2 size={3} alignItems={"center"} display={"flex"}>
                <Typography color={"var(--neutral-500)"} fontSize={12}>
                  Total Baskets: <b>{data?.length}</b>
                </Typography>
              </Grid2>
              <Grid2
                size={6}
                justifyContent={"flex-end"}
                alignItems={"center"}
                display={"flex"}
                gap={1}
              >
                {userData?.userRole === UserRoleTypes.advisor && (
                  <GKButton
                    variant="contained"
                    size="medium"
                    onClick={() => {
                      setShowCreateBasket(true);
                    }}
                    startIcon={<PlusIcon width={14} />}
                  >
                    Create Basket
                  </GKButton>
                )}
                <GKButton
                  variant="outlined"
                  color="dark"
                  size="medium"
                  onClick={() => {
                    navigate("/app/equity-basket/orders");
                  }}
                  startIcon={<TagBorderIcon width={14} />}
                >
                  Total Orders
                </GKButton>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12}>
            <Divider />
          </Grid2>

          <Grid2
            size={12}
            p={3}
            style={{
              maxHeight: "calc(100vh - 184px)",
              overflow: "auto",
              borderRadius: 10,
            }}
          >
            {data?.length !== 0 ? (
              <Grid2 container spacing={3}>
                {data
                  ?.filter((dataItems: any) =>
                    dataItems?.name
                      ?.toLowerCase()
                      ?.includes(searchText?.toLowerCase()),
                  )
                  ?.map((item: any, index: number) => (
                    <Grid2 size={12} key={index}>
                      <EquityBasketCard
                        key={index}
                        id={item?.id}
                        modelPortfolio={item}
                        isFetching={isFetching}
                        orderSimulationTemplate={
                          orderSimulationTemplate?.data?.formData
                        }
                      />
                    </Grid2>
                  ))}{" "}
              </Grid2>
            ) : (
              <Grid2 container>
                <Grid2 size={12}>
                  <Card
                    style={{
                      height: "100%",
                    }}
                  >
                    <NoData text="No equity basket found." />
                  </Card>
                </Grid2>
              </Grid2>
            )}
          </Grid2>
        </Grid2>
      </DashboardLayout>
      <Show.When isTrue={showCreateBasket}>
        <CreateBasketModal
          open={showCreateBasket}
          setOpen={setShowCreateBasket}
        />
      </Show.When>
    </>
  );
};

export default EquityBasket;
